<template>
  <div class="item-container">
    {{ suborder }} <i class="el-icon-loading float-icon">
    </i>
  </div>
</template>

<script>
export default {
  name: 'NotVerifiedSoc',
  props: ['suborder'],
};
</script>

<style  scoped>
  .item-container {
    width: 100%;
  }
  .float-icon {
    margin: 6px;
    font-size: 18px;
    float: right;
  }
</style>
